import { useForm, zodResolver } from '@mantine/form';
import { useEffect } from 'react';

import { CreateGoodLocationSchema, UpdateGoodLocationSchema } from '@e-origin/contracts';

import { useSaveGoodLocation } from '@hooks/declarant';

export const useEditGoodsLocationFormInitializer = ({ declarant, goodLocationToEdit }) => {
  const saveGoodsLocationMutation = useSaveGoodLocation();

  const onSubmit = async (values) => {
    return await saveGoodsLocationMutation.mutateAsync({
      goodLocation: values,
      declarantId: declarant._id,
    });
  };

  const buildInitialValues = (goodLocation) => ({
    _id: goodLocation?._id ?? '',
    defaultLocation: goodLocation?.defaultLocation ?? false,
    type: goodLocation?.type ?? '',
    qualifierOfIdentification: goodLocation?.qualifierOfIdentification ?? '',
    unLocode: goodLocation?.unLocode ?? '',
    unLocodeDescription: goodLocation?.unLocodeDescription ?? '',
    customsOffice: {
      referenceNumber: goodLocation?.customsOffice?.referenceNumber ?? '',
    },
    gnss: {
      latitude: goodLocation?.gnss?.latitude ?? '',
      longitude: goodLocation?.gnss?.longitude ?? '',
    },
    economicOperator: {
      identificationNumber: goodLocation?.economicOperator?.identificationNumber ?? '',
    },
    authorisationNumber: goodLocation?.authorisationNumber ?? '',
    additionalIdentifier: goodLocation?.additionalIdentifier ?? '',
    address: {
      street: goodLocation?.address?.street ?? '',
      postcode: goodLocation?.address?.postcode ?? '',
      city: goodLocation?.address?.city ?? '',
      country: goodLocation?.address?.country ?? '',
    },
    postcode: {
      postcode: goodLocation?.postcode?.postcode ?? '',
      houseNumber: goodLocation?.postcode?.houseNumber ?? '',
      country: goodLocation?.postcode?.country ?? '',
    },
    warehouses: goodLocation?.warehouses ?? [],
  });

  const form = useForm({
    initialValues: buildInitialValues(goodLocationToEdit),
    validate: zodResolver(goodLocationToEdit?._id ? UpdateGoodLocationSchema : CreateGoodLocationSchema),
    validateInputOnBlur: true,
  });

  useEffect(() => {
    form.setValues(buildInitialValues(goodLocationToEdit));
  }, [goodLocationToEdit]);

  return { form, onSubmit, declarant };
};
